export default "<tc-dialog-content [config]=\"dialogConfig\">\r\n  <tc-smart-form [storeKey]=\"formStoreKey\"></tc-smart-form>\r\n</tc-dialog-content>\r\n";